import { combineReducers } from 'redux';
import buyStorageReducer from '../buy/buyStorageReducer';
import sellWizardReducer from '../sell/sellWizardReducer';
import standardDepositWizardReducer from './standardDepositWizardReducer';
import withdrawalWizardReducer from './withdrawalWizardReducer';
import buyDeliveryReducer from '../buy/buyDeliveryReducer';
import sellFromHomeHistoryReducer from './sellFromHomeHistoryReducer';

export default combineReducers({
  buyStorage: buyStorageReducer,
  buyDelivery: buyDeliveryReducer,
  sellWizard: sellWizardReducer,
  standardDepositWizard: standardDepositWizardReducer,
  withdrawalWizard: withdrawalWizardReducer,
  sellFromHomeHistory: sellFromHomeHistoryReducer,
});
